module.exports = __webpack_public_path__ + "static/media/AvalancheFriends11.2195051a.jpg";